// MUI Components
import { Grid, Tooltip, Typography } from "@mui/material";
import { InfoIcon } from "../../../assets/icons";

const defaultTitleStyle = { color: "#000", fontSize: "16px", fontWeight: 500 };
const defaultTooltipStyle = { color: "#000", height: "20px", width: "20px" };

const TitleWithTooltip = ({
  title,
  tooltip,
  titleStyle = defaultTitleStyle,
  tooltipStyle = defaultTooltipStyle,
  tooltipPlacement = "bottom",
}) => {
  return (
    <Grid item display="flex" alignItems="center">
      <Typography
        sx={{
          ...defaultTitleStyle,
          ...titleStyle,
          marginRight: tooltip ? "4px" : "0px",
        }}
      >
        {title}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip} placement={tooltipPlacement}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <InfoIcon {...defaultTooltipStyle} {...tooltipStyle} />
          </span>
        </Tooltip>
      )}
    </Grid>
  );
};

export default TitleWithTooltip;
